import DOMPurify from 'dompurify';
import { valueIsArray, valueIsObject } from './validators';

export function sanitizeValue(value: any) {
  let nextValue = value;

  if (typeof value === 'string') nextValue = DOMPurify.sanitize(value).trim();
  else if (typeof value === 'object' && value instanceof Date) return value;
  else if (valueIsObject(value)) {
    const entries = Object.entries(value);
    const sanitizedEntries = entries.map(([k, v]) => [k, sanitizeValue(v)]);

    nextValue = Object.fromEntries(sanitizedEntries);
  } else if (valueIsArray(value)) {
    nextValue = Array.from(value).map(sanitizeValue);
  }

  return nextValue;
}

export function sanitizeForCsv(value: any) {
  if (typeof value !== 'string') {
    value = String(value);
  }

  const dangerousChars = ['=', '+', '-', '@'];
  if (dangerousChars.includes(value.charAt(0))) {
    return `'${value}`;
  }
  return value;
}
